import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9d878b58&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=9d878b58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d878b58",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActionPopover: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/ActionPopover/index.vue').default,Share: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/Share/index.vue').default})
